import * as Yup from 'yup';

export default Yup.object().shape({
  coupon_code: Yup.string()
    .required("Coupon is required."),

  start_date: Yup.date()
    .required("Start date is required."),

  end_date: Yup.date()
    .required("End date is required.")
    .min(
      Yup.ref("start_date"),
      "End date must be greater than start date"
    ),

  discount_percentage: Yup.number()
    .typeError("Discount percentage must be a number.")
    .required("Discount percentage is required.")
    .min(1, "Discount must be at least 1%")
    .max(100, "Discount cannot exceed 100%"),
});